<template>
  <div class="featured">
    <FeaturedCompMobile v-if="isMobile" />
    <FeaturedComp v-else />
  </div>
</template>


<script>
import FeaturedComp from "@/components/Featured.vue";
import FeaturedCompMobile from "@/components/FeaturedMobile.vue";

export default {
  name: "Featured",
  components: { FeaturedComp, FeaturedCompMobile },

  data() {
    return {
      isMobile: false
    };
  },
  created() {
    this.checkDeviceType();
    window.addEventListener('resize', this.checkDeviceType);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceType);
  },
  methods: {
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    }
  }
};
</script>